import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard'; 
import firebase from './../../../firebase';
import { Button,  Col, Form, Row , InputGroup} from 'react-bootstrap'; 

import {   useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const NewMailings = () => {
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({});
    const [l, setL] = React.useState(false);

  const navigate = useNavigate();
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
        return;
    } 
    setValidated(true);
    setL(true); 

     
    let d = formd; 
    d.create_At = new Date();
    d.update_At = new Date();


        firebase.firestore().collection('mailingslist').add(d).then(() => {
            console.log("Document successfully written!");
            toast.success("Liste d'email créer avec succès");
            navigate('/mailings');  
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            // ..
            setL(false); 
            toast.error(errorMessage);
        });
    
    };


  const handleChange = e => { 
    let d = {...formd}; 
    d[e.target.name] = e.target.value; 
    setFrom(d); 
  };


  return (
    <FalconComponentCard>
        <FalconComponentCard.Header title="Nouvelle liste d'email" light={false} noPreview={true}  />
        <FalconComponentCard.Body >
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="title">
                <Form.Label>Titre</Form.Label>
                <Form.Control
                onChange={handleChange}
                    required
                    name="title" 
                    type="text"
                    placeholder="Votre titre.." 
                />
                <Form.Control.Feedback type="invalid">
                    Veuillez indiquez votre titre.
                </Form.Control.Feedback>
                <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                </Form.Group> 
 
            </Row>  
            <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Créer'}</Button>
            </Form>
           </FalconComponentCard.Body>
    </FalconComponentCard>
  ); 
//   <> 

//     <FalconComponentCard>
//       
//       <FalconComponentCard.Body code={exampleCode} language="jsx" />
//     </FalconComponentCard> 
//   </>
  };

export default NewMailings;
